module.exports = __webpack_public_path__ + "static/media/moons_dudas_cita-1500.8ee5746b.jpg";